import { Menu, type MenuProps } from '@mui/material';
import { styled } from '@mui/material/styles';

/** Themed menu wrapper — applies primary-colour hover tint to all MUI MenuItems */
export const ThemedMenu: React.ComponentType<MenuProps> = styled(Menu)(({ theme }) => ({
  '& .MuiMenuItem-root:hover': {
    backgroundColor: `${theme.palette.primary.main}14`,
    color: theme.palette.primary.main,
  },
  '& .MuiMenuItem-root.Mui-selected': {
    backgroundColor: `${theme.palette.primary.main}1F`,
  },
  '& .MuiMenuItem-root.Mui-selected:hover': {
    backgroundColor: `${theme.palette.primary.main}29`,
  },
}));
